import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import * as _ from 'lodash-es';
import { FormDialogComponent, FormDialogOption } from '../form-dialog/form-dialog.component';
import { CdkDragDrop, moveItemInArray, CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslateIsoPipe } from '../../../utils/translate-iso.pipe';
// import { UrlService } from 'src/app/services/url.service';



export interface SelectDialogOptions extends FormDialogOption {
    label: string;
    multiple?: boolean;
    data?: any[];
    defaultValue?: any;
    predicate?: (v: any) => boolean;
    display?: (v: any) => string;
    map?: (v: any) => any;
    order?: boolean;
}

@Component({
    selector: 'app-select-dialog',
    templateUrl: './select-dialog.component.html',
    styleUrls: ['./select-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CdkScrollable, MatDialogContent, MatDialogTitle, FormsModule, ReactiveFormsModule, RxReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, CdkDropList, CdkDrag, MatDialogActions, MatButton, MatDialogClose, TranslatePipe, TranslateIsoPipe]
})
export class SelectDialog extends FormDialogComponent implements OnInit {
    config: SelectDialogOptions;


    // get controls(): { [x: string]: FormControl; } { return this.form.controls as { [x: string]: FormControl; }; }
    label: string = '';
    multiple: boolean = true;
    protected _data: any[] = [];
    get data(): any[] {
        return this._data.filter(this.predicate);
    }
    predicate: (v: any) => boolean;
    display: (v: any) => string;
    map: (v: any) => any;
    order: boolean = false;


    get isValid(): boolean { return this.form.valid; }

    constructor() {
        const config = inject<SelectDialogOptions>(MAT_DIALOG_DATA);

        super();
        this.config = config;


        // INIT FROM OPTIONS
        this.multiple = config.multiple || true;
        this.label = config.label || '';
        this._data = config.data || [];
        this.predicate = config.predicate || ((v: any) => true);
        this.display = config.display || ((v: any) => v);
        this.map = config.map || ((v: any) => v);
        this.order = config.order || false;

        this.form = this.fb.group({
            data: new FormControl(config.defaultValue || (this.multiple ? [] : null), [Validators.required]),
        });
    }

    drop(event: CdkDragDrop<any>) {
        moveItemInArray(this.controls['data'].value, event.previousIndex, event.currentIndex);
    }

    async ngOnInit() {

    }

    submit() {
        this.dialogRef.close(_.cloneDeep(this.form.value));
    }
}
